import React, { useEffect, useState } from 'react';
import {
  TextField,
  CircularProgress,
  Autocomplete,
  Box,
  Typography,
} from '@mui/material';
import _ from 'lodash';
import * as partnerApi from '../../../../lib/api/partner';

const PartnerSelectbox = ({ formik, name, label, variant, margin, required, size }) => {
  
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);
  //const loading = open && options.length === 0;
  const loading = options.length === 0;
  const [defaultValue, setDefaultValue] = useState(null);

  useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      try {
        const response = await partnerApi.getPartners();
        const paretnerList =_.uniqBy(response.data.list,'partnerNm');//동일 label 오류 처리
       
        if (active) {
          setOptions([...paretnerList]);
          
        }
      } catch (err) {
        console.log(err);
      }
    })();

    return () => {
      active = false;
    };
  }, []);

  useEffect(() => {
    if(options.length > 0){
      if (
        formik.values[name] !== null &&
        formik.values[name] !== '' &&
        formik.values[name] !== undefined
      ) {
        const selected = _.find(
          options,
          (item) => item.partnerUuid === formik.values[name],
        );
        //console.log(selected,"selected");
        setDefaultValue(selected);
      } 
    }
  }, [options, formik.values[name]]);
  

  return (
    <Autocomplete
      loading={loading}
      id={name}
      options={options}
      open={open}
      
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      onInputChange={(event, newInputValue) => {
        if (newInputValue === '' || newInputValue === null) {
          formik.setFieldValue(name, '');
          setDefaultValue(newInputValue);
        }
      }}
      onChange={(event, newValue) => {
        //console.log(newValue, 'newValue');
        if (newValue !== null && newValue !== undefined) {
          setDefaultValue(newValue);
          formik.setFieldValue(name, newValue?.partnerUuid);
        }
      }}
       freeSolo
      selectOnFocus
      clearOnBlur
      autoHighlight
      key={option => option.partnerUuid}
      value={defaultValue}
      //getOptionLabel={(option) => `(${option.partnerTyp})${option.partnerNm}` ||''}
      getOptionLabel={(option) =>
        typeof option === 'string' ? '' : `(${option.partnerTyp})${option.partnerNm}`
      }
      isOptionEqualToValue={(option, value) => {
        return option === value;
      }}
      renderOption={(props, option) => (
        <Box
          key={option.partnerUuid}
          component="li"
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
            alignItems: 'center',
            p: 1,
          }}
          {...props}
        >
          <Box>
            <Typography display="inline" variant="body2" sx={{ mr: 1 }}>
              ({option.partnerTyp})
            </Typography>
            <Typography display="inline" variant="subtitle1">
              {option.partnerNm}
            </Typography>
          </Box>
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          margin={margin}
          variant={variant}
          label={label}
          size={size}
          required={required}
          error={formik.touched[name] && Boolean(formik.errors[name])}
          helperText={formik.touched[name] && formik.errors[name]}
          // error={true}
          // helperText="Example error"
          InputProps={{
            ...params.InputProps,
            autoComplete: 'new-password', // disable autocomplete and autofill
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
};

export default PartnerSelectbox;
